import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  showDevWarning?: boolean;
  onClick?: () => void;
}

function LuxLoyaltyPackageTargetUpgradesWarning({ open, onClose, showDevWarning, onClick }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onClick={onClick}
      aria-labelledby="alert-dialog-title-package-target-upgrades-warning"
      aria-describedby="alert-dialog-description-package-target-upgrades-warning"
    >
      <DialogTitle id="alert-dialog-title-package-target-upgrades-warning">
        Changes to Target Upgrade Package
      </DialogTitle>
      <DialogContent>
        {!showDevWarning && (
          <DialogContentText id="alert-dialog-description-package-target-upgrades-warning">
            The loyalty development team are currently working on migrating the existing target upgrade packages to a
            new data field. Please continue to use the legacy/existing functionality for now.
          </DialogContentText>
        )}
        {showDevWarning && (
          <DialogContentText id="alert-dialog-description-package-target-upgrades-warning">
            Please do not use this field. It is currently undergoing development and testing by the loyalty development
            team.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LuxLoyaltyPackageTargetUpgradesWarning;
